import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useMenu } from "hook/useMenu";

/**
 * uri 변경 추적 컴포넌트
 * uri가 변경될 때마다 pageview 이벤트 전송
 */
const RouteChangeTracker = (): JSX.Element => {
  const location = useLocation();
  const { lists } = useMenu({});

  // location 변경 감지시 pageview 이벤트 전송
  useEffect(() => {
    const category = lists.find((menu) =>
      location.pathname.includes(
        menu?.routeName || menu?.includeRouteName || ""
      )
    );
    const menuName = lists.some((menu) =>
      menu.children?.some((child) =>
        location.pathname.includes(child?.routeName || "")
      )
    )
      ? lists.find((menu) =>
          menu.children?.some((child) =>
            location.pathname.includes(child?.routeName || "")
          )
        )?.name
      : category?.name;
    if (window.dataLayer && menuName) {
      window.dataLayer.push({
        event: "page_view",
        page_title: menuName,
        page_location: window.location.href,
        page_path: location.pathname,
      });
    }
  }, [lists, location]);
  return <></>;
};

export default RouteChangeTracker;
